<template>
  <el-container class="IncomePrint">
    <el-main ref="IncomePrintArea" class="p-0 IncomePrintArea" :class="{ 'print-scale-85': showPyungProcessingCost }">
      <div
        v-for="(sdata, index) in slice_items"
        class="w-full print-divider pb-default"
        :key="sdata.id"
      >
        <div id="excel_table">
          <table class="w-full">
            <tr>
              <td
                colspan="13"
                style="font-size:35px; font-weight:bold; text-align:center;"
              >거 래 내 역 리 스 트</td>
            </tr>
            <tr>
              <td colspan="13" style="font-size:15px;">{{bankAccountId}} 예금주 {{company.name}}</td>
            </tr>
          </table>
          <table
            class="w-full border transaction"
            cellspacing="0"
            cellpadding="2"
            style="border-bottom:none;"
          >
            <col width="2%" />
            <col width="8%" />
            <col width="15%" />
            <col width="8%" />
            <col width="17%" />
            <col width="2%" />
            <col width="8%" />
            <col width="15%" />
            <col width="8%" />
            <col />
            <col />
            <col />
            <col />
            <tr>
              <!-- 공급받는자 -->
              <th rowspan="4">공 급 받 는 자</th>
              <th>인 쇄 일</th>
              <td style="text-align:left;">{{util.getDate()}}</td>
              <th>검색기간</th>
              <td>{{period.startDate}} - {{period.endDate}}</td>
              <!-- 공급자 -->
              <th rowspan="4">공 급 자</th>
              <th style="min-width: 70px;">등록번호</th>
              <td colspan="6">{{company.crn}}</td>
            </tr>
            <tr>
              <!-- 공급받는자 -->
              <th>소재지</th>
              <td colspan="3">{{customer.addr}}</td>
              <!-- 공급자 -->
              <th>소재지</th>
              <td colspan="6">
                <AFitText>{{company.addr}}</AFitText>
              </td>
            </tr>
            <tr>
              <!-- 공급받는자 -->
              <th>상 호</th>
              <td colspan="3" class="bold">
                {{customer.name}}
                <span class="ml-default">귀중</span>
              </td>
              <!-- 공급자 -->
              <th>상호</th>
              <td colspan="6" style="min-width: 180px;">{{company.name}}</td>
            </tr>
            <tr>
              <!-- 공급받는자 -->
              <th>연락처</th>
              <td style="min-width: 100px;">{{customer.tel}}</td>
              <th style="min-width: 40px;">팩 스</th>
              <td style="min-width: 70px;">{{customer.fax}}</td>
              <!-- 공급자 -->
              <th>전 화</th>
              <td style="min-width: 100px;">{{company.tel}}</td>
              <th style="min-width: 40px;">팩 스</th>
              <td colspan="4" style="min-width: 70px;">{{company.fax}}</td>
            </tr>
            <tr></tr>
          </table>
          <!-- 엑셀 출력물은 데이터가 전부 나와야하기 때문에 unvisible테이블을 하나 생성 -->
          <div class="none">
            <table
              class="w-full border table-fs12 print-list table-fixed"
              cellspacing="0"
              cellpadding="3"
            >
              <col width="30" />
              <col width="80" />
              <col :width="showPyungProcessingCost ? 100 : 130" />
              <col width="80" />
              <col width="50" />
              <col width="25" />
              <col width="30" />
              <col v-if="isTotalPyung" width="55" />
              <col width="60" />
              <col v-if="showPyungProcessingCost" :width="60" />
              <col v-if="showPyungProcessingCost" :width="60" />
              <col width="75" />
              <col width="60" />
              <col width="75" />
              <col width="85" />
              <col width="60"/>
              <col />
              <tr>
                <th>No</th>
                <th>거래일</th>
                <th>품목</th>
                <th>{{$t('lang.size')}}</th>
                <th>평</th>
                <th>수량</th>
                <th>단위</th>
                <th v-if="isTotalPyung">총평수</th>
                <th>단가</th>
                <th v-if="showPyungProcessingCost">평단가</th>
                <th v-if="showPyungProcessingCost">가공비</th>
                <th>공급가액</th>
                <th>세액</th>
                <th>금액</th>
                <th>미수금</th>
                <th>현장</th>
                <th>비고</th>
              </tr>
              <tr
                v-for="(item, i) in data"
                v-bind:key="item.id"
                v-bind:class="{mark: item.type_flag === '2', 'day-sum-row' : item.sum_row }"
              >
                <td class="align-center">{{i+1}}</td>
                <td class="align-center">{{item.deal_date}}</td>
                <td class="mark">
                  <div class="ellipsis">{{item.product_name}}</div>
                </td>
                <td>{{item.size}}</td>
                <td>{{isGlass(item,item.size)}}</td>
                <td class="align-center">{{util.addComma(item.amount)}}</td>
                <td class="align-center mark">{{item.unit_name}}</td>
                <td v-if="isTotalPyung">{{isGlassTotalPyung(item,item.size)}}</td>
                <td class="cell-number">{{util.addComma(item.cost)}}</td>
                <td v-if="showPyungProcessingCost" class="cell-number">{{util.addComma(item.pyung_cost)}}</td>
                <td v-if="showPyungProcessingCost" class="cell-number">{{util.addComma(item.item_processing_cost)}}</td>
                <td class="cell-number">{{util.addComma(item.supply_price)}}</td>
                <td class="cell-number">{{util.addComma(item.tax)}}</td>
                <td class="cell-number mark">{{util.addComma(item.price)}}</td>
                <td class="cell-number">{{util.addComma(item.balance)}}</td>
                <td>
                  <div class="ellipsis">{{item.field}}</div>
                </td>
                <td>
                  <div class="ellipsis">{{item.desc}}</div>
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div class="of-auto mt-default" v-bind:class="{'of-hidden': of_hidden}">
          <table
            class="w-full border table-fs12 print-list table-fixed"
            cellspacing="0"
            cellpadding="3"
          >
            <col width="30" />
            <col width="80" />
            <col :width="showPyungProcessingCost ? 100 : 130" />
            <col width="80" />
            <col width="50" />
            <col width="25" />
            <col width="30" />
            <col v-if="isTotalPyung" width="55" />
            <col width="60" />
            <col v-if="showPyungProcessingCost" :width="60" />
            <col v-if="showPyungProcessingCost" :width="60" />
            <col width="75" />
            <col width="60" />
            <col width="75" />
            <col width="85" />
            <col width="60"/>
            <col />
            <tr>
              <th>No</th>
              <th>거래일</th>
              <th>품목</th>
              <th>{{$t('lang.size')}}</th>
              <th>평</th>
              <th>수량</th>
              <th>단위</th>
              <th v-if="isTotalPyung">총평수</th>
              <th>단가</th>
              <th v-if="showPyungProcessingCost">평단가</th>
              <th v-if="showPyungProcessingCost">가공비</th>
              <th>공급가액</th>
              <th>세액</th>
              <th>금액</th>
              <th>미수금</th>
              <th>현장</th>
              <th>비고</th>
            </tr>
            <tr
              v-for="(item, i) in sdata.items"
              v-bind:key="item.id"
              v-bind:class="{mark: item.type_flag === '2', 'day-sum-row' : item.sum_row }"
            >
              <td class="align-center">{{displayIndex(index, i)}}</td>
              <td class="align-center">{{displayDealDate(index, i)}}</td>
              <td class="mark">
                <div class="ellipsis">{{item.product_name}}</div>
              </td>
              <td>{{item.size}}</td>
              <td class="total">{{item.is_last ? item.pyung : isGlass(item,item.size)}}</td>
              <td class="align-center">{{util.addComma(item.amount)}}</td>
              <td class="align-center mark">{{item.unit_name}}</td>
              <td v-if="isTotalPyung" class="total">{{item.item_pyung ? item.item_pyung : isGlassTotalPyung(item,item.size)}}</td>
              <td class="cell-number">{{util.addComma(item.cost)}}</td>
              <td v-if="showPyungProcessingCost" class="cell-number">{{util.addComma(item.pyung_cost)}}</td>
              <td v-if="showPyungProcessingCost" class="cell-number">{{util.addComma(item.item_processing_cost)}}</td>
              <td class="cell-number">{{util.addComma(item.supply_price)}}</td>
              <td class="cell-number">{{util.addComma(item.tax)}}</td>
              <td class="cell-number mark">{{util.addComma(item.price)}}</td>
              <td class="cell-number">{{util.addComma(item.balance)}}</td>
              <td>
                <div class="ellipsis">{{item.field}}</div>
              </td>
              <td>
                <div class="ellipsis">{{item.desc}}</div>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </el-main>
    <el-footer>
      <el-button
        type="primary"
        v-shortkey="['f8']"
        @shortkey.native="handleClickPrint"
        @click="handleClickPrint"
      >인 쇄 (F8)</el-button>
      <el-button @click="handleClickExcel">양식 다운로드</el-button>
      <el-button @click="handlClickBomExcel">데이터 다운로드</el-button>
      <el-button @click="handleClickClose" class="right">{{$t('button.close')}} (Esc)</el-button>
    </el-footer>
  </el-container>
</template>

<script>
import export2csv from "@/common/function/export2csv";
import { mapGetters } from "vuex";
import Vue from "vue";
import { company_info } from "@/common/mixins/company_info";
import AFitText from "@/shared/AFitText";
import Print from "@/plugins/print/print";

Vue.use(Print);

export default {
  name: "IncomePrint",
  components: { AFitText },
  mixins: [company_info],
  data() {
    return {
      company: {
        show_pyung_processing_cost: false,
        income_trade_print_pyung: false,
      },
      title: "거래내역리스트",
      items: [],
      result: null,
      of_hidden: false,
      is_printed: false
    };
  },
  props: {
    period: {
      type: Object,
      required: true
    },
    customer: {
      type: Object,
      required: true
    },
    sum_flag: {
      type: Boolean
    },
    data: {
      type: Array,
      required: true
    }
  },
  watch: {
    table_config() {
      this.loadConfig()
    },
  },
  computed: {
    ...mapGetters(["table_account"]),
    slice_items() {
      let items = [];
      let cur_items;
      let index = 0;
      this.items.forEach(item => {
        if (index % this.indexDivider === 0) {
          cur_items = {
            id: index,
            items: []
          };
          items.push(cur_items);
        }
        cur_items.items.push(item);
        index++;
      });
      items.forEach(item => {
        item.account = this.parseAccount(item);
      });
      return items;
    },
    showPyungProcessingCost() {
      return this.company.show_pyung_processing_cost;
    },
    isTotalPyung() {
      return this.company.income_trade_print_pyung;
    },
    bankAccountId() {
      let account_id = this.customer.account_id;
      if (!account_id) {
        let item = this.table_config.find(c => c.key === "account");
        account_id = item.value.represent;
      }
      let account = this.table_account.find(o => o.id === account_id);
      return account ? account.bank_name + " " + account.number : "";
    },
    indexDivider() {
      return this.showPyungProcessingCost ? 30 : 20
    }
  },
  mounted() {
    this.loadConfig();
    this.calculatePrice();
  },
  methods: {
    calculatePrice() {
      this.items = Object.assign([], this.data);
      let total_pyung = 0;
      let total_supply_price = 0;
      let total_item_processing_cost = 0;
      let total_tax = 0;
      let total_price = 0;
      let last_balance = 0;
      if (this.sum_flag === true) {
        let day_old = "";
        let day_cur = "";
        let day_supply_price = 0;
        let day_tax = 0;
        let day_price = 0;
        let day_balance = 0;
        let day_pyung = 0;
        for (let i = 0; i < this.items.length; i++) {
          let item = this.items[i];
          day_cur = item.deal_date;
          if (day_old !== day_cur) {
            if (day_old !== "") {
              this.items.splice(i, 0, {
                sum_row: true,
                deal_date: day_old,
                product_name: "소 계",
                supply_price: day_supply_price,
                item_pyung: day_pyung.toFixed(2),
                tax: day_tax,
                price: day_price,
                balance: day_balance
              });
              day_pyung = 0;
              day_supply_price = 0;
              day_tax = 0;
              day_price = 0;
              day_balance = 0;
              i++;
            }
            day_old = day_cur;
          }
          if (item.type_flag === "1") {
            day_supply_price += item.supply_price;
            day_tax += item.tax;
            day_price += item.price;
            day_pyung += Number(this.isGlassTotalPyung(item, item.size))
          }
          day_balance = item.balance;
        }
        if (
          this.items.length > 0 &&
          !this.items[this.items.length - 1].sum_row
        ) {
          this.items.splice(this.items.length + 1, 0, {
            sum_row: true,
            product_name: "소 계",
            supply_price: day_supply_price,
            item_pyung: day_pyung.toFixed(2),
            tax: day_tax,
            price: day_price,
            balance: day_balance
          });
        }
      }
      this.items.forEach(item => {
        if (item.type_flag === "1") {
          total_pyung += Number(this.isGlass(item,item.size)) * item.amount
          total_supply_price += item.supply_price;
          total_item_processing_cost += item.item_processing_cost || 0;
          total_tax += item.tax;
          total_price += item.price;
        }
        last_balance = item.balance;
      });
      this.items.splice(this.items.length + 2, 0, {
        is_last: true,
        sum_row: true,
        total_sum: true,
        product_name: "전체 소계",
        item_pyung: this.isTotalPyung ? total_pyung.toFixed(2) : '',
        supply_price: total_supply_price,
        item_processing_cost: total_item_processing_cost,
        tax: total_tax,
        price: total_price,
        balance: last_balance
      });
    },
    parseAccount(data) {
      let pre_balance = 0;
      let balance = 0;
      let collect = 0;
      let total = 0;
      if (data.items[0].sum_row) {
        // 첫 번쨰 행이 소계라면
        pre_balance = data.items[0].balance;
      } else if (data.items[0].type_flag === "2") {
        // 첫 번째 행이 수금이라면
        pre_balance = data.items[0].balance + data.items[0].price;
      } else {
        pre_balance = data.items[0].balance - data.items[0].price;
      }
      if (this.sum_flag && data.items[data.items.length - 2]) {
        balance = data.items[data.items.length - 2].balance;
        if (
          data.items[data.items.length - 1].sum_row &&
          !data.items[data.items.length - 1].total_sum
        ) {
          // 마지막 행이 소계라면
          balance = data.items[data.items.length - 3].balance;
        }
      }
      data.items.forEach(item => {
        if (item.collect_price) {
          collect += item.collect_price;
        }
        if (item.type_flag === "1") {
          total += item.price;
        }
      });
      return {
        pre_balance: pre_balance,
        collect: collect,
        total: total,
        balance: balance
      };
    },
    displayDealDate(sIndex, index) {
      let sItem = this.slice_items[sIndex];
      if (index === 0) {
        return sItem.items[index].deal_date;
      }
      if (sItem.items[index - 1].deal_date === sItem.items[index].deal_date) {
        if (sItem.items[index].sum_row) {
          return sItem.items[index].deal_date;
        }
        return "";
      } else {
        return sItem.items[index].deal_date;
      }
    },
    displayIndex(sIndex, index) {
      let i = index + 1;
      if (sIndex === 0) {
        return i;
      }
      return sIndex * this.indexDivider + i;
    },
    doRegister() {
      let sales = [];
      let collects = [];
      this.data.forEach(item => {
        if (item.type_flag === "2") {
          collects.push(item.collect_id);
        } else if (item.type_flag && item.type_flag !== "3") {
          sales.push(item.sale_id);
        }
      });
      let data = {
        sales: sales,
        collects: collects
      };
      this.api.registerIncomeTransaction(data).then(res => {
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
          return;
        }
        this.result = true;
        this.doPrint();
      });
    },
    doPrint() {
      this.of_hidden = true;
      this.is_printed = true;
      this.$print(this.$refs.IncomePrintArea);
    },
    handleClickPrint() {
      if (this.result) {
        this.doPrint();
      } else {
        this.util.confirm(
          this,
          this.title,
          "발행하시겠습니까?",
          this.doRegister
        );
      }
    },
    handleClickClose() {
      this.$emit("completed", this.is_printed);
    },
    handlClickBomExcel() {
      let items = [];
      let fields = [
        { value: "deal_date", label: "거래일" },
        { value: "product_name", label: "품목" },
        { value: "size", label: "규격" },
        { value: "pyung", label: "평" },
        { value: "amount", label: "수량" },
        { value: "unit_name", label: "단위" },
        { value: "cost", label: "단가" },
        { value: "supply_price", label: "공급가액" },
        { value: "tax", label: "세액" },
        { value: "price", label: "금액" },
        { value: "balance", label: "미수금" },
        { value: "field", label: "현장" },
        { value: "desc", label: "비고" }
      ];
      this.data.forEach(d => {
        let data = {
          deal_date: d.deal_date,
          product_name: d.product_name,
          size: d.size,
          pyung: this.isGlass(d, d.size),
          amount: d.amount,
          unit_name: d.unit_name,
          cost: d.cost,
          supply_price: d.supply_price,
          tax: d.tax,
          price: d.price,
          balance: d.balance,
          field: d.field,
          desc: d.desc
        };
        items.push(data);
      });
      export2csv.export(items, fields, "거래내역리스트");
    },
    handleClickExcel() {
      let tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
      tab_text +=
        '<head><meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8">';
      tab_text += "<xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
      tab_text += "<x:Name>" + this.title + "</x:Name>";
      tab_text +=
        "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
      tab_text += "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
      tab_text += "<table>";
      const temp = document.getElementById("excel_table").innerHTML;
      tab_text += temp;
      tab_text += "</table></body></html>";
      const fileName = this.title + ".xls";
      const a_tag = document.createElement("a");
      const blob = new Blob([tab_text], {
        type: "application/vnd.ms-excel;charset=utf-8;"
      });
      a_tag.href = window.URL.createObjectURL(blob);
      a_tag.download = fileName;
      a_tag.click();
    },
    isGlass(row, value) {
      if (row.product_kind === "GLASS" && value) {
        if (value.includes("/")) value = value.split("/")[0];
        const [horizontal, vertical] = value.split("*").map(x => Number(x));
        const return_value =
          this.util.calculatePyung(horizontal, vertical, true)
        return isNaN(return_value) ? "" : return_value < 3 ? 3 : return_value;
      }
      return "";
    },
    isGlassTotalPyung(row, value) {
      if (row.product_kind === "GLASS" && value) {
        if (value.includes("/")) value = value.split("/")[0];
        const [horizontal, vertical] = value.split("*").map(x => Number(x));
        let return_value = this.util.calculatePyung(horizontal, vertical, true)
        return isNaN(return_value) ? "" : ((return_value < 3 ? 3 : return_value) * row.amount).toFixed(2);
      }
      return "";
    }
  }
};
</script>
<style lang="scss">
.IncomePrint {
  .table-account {
    tr {
      th {
        width: 80px;
      }
      td {
        min-width: 100px;
      }
    }
  }
  .max-height {
    max-height: 500px;
  }
}
</style>
<style lang="scss" media="print">
@page a4landscape { size: A4 landscape; }
@media print {
  .IncomePrintArea.print-scale-85 {
    /* 85% 축소 */
    zoom: 0.85; /* Chrome/Edge/Safari */

    @supports not (zoom: 1) {
      transform: scale(0.85);
      transform-origin: top left;
      width: calc(100% / 0.85); /* 폭 보정 */
    }
  }
}
.IncomePrintArea {
  page: a4landscape;
  table.table-fs12 tr {
    height: 13px;
    line-height: 13px;
  }
  table.table-fs12 .day-sum-row {
    height: 13px;
    line-height: 13px;
  }
  table.table-fs12 tr th,
  table.table-fs12 tr td,
  table.transaction tr td,
  table.transaction tr th,
  .el-dialog__body {
    font-size: 13px;
  }
}
</style>